import React from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IRequest } from "../models";
import { ApprovalStatus } from "../../../../../components";
import { Button } from "antd";
import { FontFa } from "../../../../../components";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../AppRoutes";
import { useSelector } from "../../../../../store/store";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { useGetMyApprovals } from "../hooks";
import { Skeleton } from "antd";
import * as docx from "docx";
import { saveAs } from "file-saver";
import { getSummaryEmployeeRequest } from "../../../company-office/request-vehicle/TemplateDocx/Template/getSummaryEmployeeRequest";
import { getStatus } from "../utils/get-status";

export const MyApprovals: React.FC = () => {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const columns: ColumnsType<IRequest> = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render(value, record, index) {
        return getDDMMYYYFormat(record?.createdDateTime);
      },
    },
    {
      title: "Người tạo",
      dataIndex: "createdBy",
      key: "createdBy",
      render(value, record, index) {
        return record?.createdBy?.user?.displayName;
      },
    },
    {
      title: "Yêu cầu",
      dataIndex: "type",
      key: "type",
      render(value, record, index) {
        return <span className="flag warning">Yêu cầu</span>;
      },
    },
    {
      title: "Nghiệp vụ",
      dataIndex: "eCourse",
      key: "eCourse",
      render(value, record, index) {
        return record?.fields?.eMajor;
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render(value, record, index) {
        const status = getStatus({
          currentUser: currentUserName,
          requestStatus: record.fields.eRequestStatus,
          steps: [
            {
              status: record.fields.eApprovedStatus,
              approver: record.fields.eApprovedBy,
            },
            {
              status: record.fields.eApprovedByITLeadStatus,
              approver: record.fields.eApprovedByITLead,
            },
            {
              status: record.fields.eApprovedByITHeadStatus,
              approver: record.fields.eApprovedByITHead,
            },
          ],
        });

        return <ApprovalStatus status={status} />;
      },
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "Download",
      key: "Download",
      render(value, record, index) {
        return (
          <Button
            onClick={(e) => {
              e.stopPropagation();

              e.stopPropagation();

              const doc6 = getSummaryEmployeeRequest(record);

              docx.Packer.toBlob(doc6).then((blob) => {
                saveAs(
                  blob,
                  `Bảng tổng hợp nhân sự tham gia khóa học - ${getDDMMYYYFormat(
                    new Date()
                  )}.docx`
                );
              });
            }}
          >
            <FontFa name="faPrint" size={"xs"} />
          </Button>
        );
      },
    },
  ];

  const { data, isLoading } = useGetMyApprovals();

  return (
    <>
      {!isLoading && (
        <Table
          rowClassName="cursor-pointer"
          columns={columns}
          dataSource={data}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                history.push(
                  Routes.summaryEmployeeRequestDetailPage.path.replace(
                    ":id",
                    record.id
                  )
                );
              },
            };
          }}
        />
      )}
      {isLoading && <Skeleton />}
    </>
  );
};
